export default __webpack_public_path__ + "static/media/commentsGrey.db2af4e8.svg";